import { View } from 'react-native';
const BottomTabsScreen = View;
export default BottomTabsScreen;
//# sourceMappingURL=BottomTabsScreen.web.js.map